export interface PendingDownloadData {
  returnUrl: string;
  downloadType: 'all'; // only 'all' needs auth, single downloads don't need storage
}

export const storePendingDownload = (data: PendingDownloadData): void => {
  sessionStorage.setItem('pendingBenchmarkDownload', JSON.stringify(data));
};

export const getPendingDownload = (): PendingDownloadData | null => {
  const stored = sessionStorage.getItem('pendingBenchmarkDownload');
  return stored ? JSON.parse(stored) : null;
};

export const clearPendingDownload = (): void => {
  sessionStorage.removeItem('pendingBenchmarkDownload');
}; 